/**
 * KAN-1003: отрисовка юридического текста из данных (src/content/legal).
 */
import { Link } from 'react-router-dom';
import type { LegalDocument, LegalInline, LegalParagraph } from '@/content/legal/types';

const LINK_CLASS = 'font-medium text-blue-600 underline-offset-2 hover:underline';

function InlinePart({ part }: { part: LegalInline }) {
  if (typeof part === 'string') return <>{part}</>;
  if ('to' in part) {
    return (
      <Link to={part.to} className={LINK_CLASS}>
        {part.text}
      </Link>
    );
  }
  return (
    <a href={part.href} className={LINK_CLASS}>
      {part.text}
    </a>
  );
}

export function LegalParagraphText({ paragraph }: { paragraph: LegalParagraph }) {
  const parts: readonly LegalInline[] = typeof paragraph === 'string' ? [paragraph] : paragraph;
  return (
    <p className="leading-relaxed text-gray-700">
      {parts.map((part, i) => (
        <InlinePart key={i} part={part} />
      ))}
    </p>
  );
}

/** Заголовок h1 документа, редакция и разделы. */
export function LegalDocumentView({ document }: { document: LegalDocument }) {
  return (
    <article className="space-y-6">
      <header className="space-y-1">
        <h1 className="text-2xl font-bold text-gray-900 sm:text-3xl">{document.title}</h1>
        <p className="text-sm text-gray-500">{document.edition}</p>
      </header>
      {document.sections.map((section) => (
        <section key={section.heading} className="space-y-3">
          <h2 className="text-lg font-semibold text-gray-900">{section.heading}</h2>
          {section.paragraphs.map((paragraph, i) => (
            <LegalParagraphText key={i} paragraph={paragraph} />
          ))}
        </section>
      ))}
    </article>
  );
}
